<template>
  <div>
    <div>
      <custom-loader v-if="loader"/>
      <b-form @submit="onSubmit" v-else>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Tab name*">
            <b-input
              v-model="modalData.logistics_tab_name"
              :class="{
                'is-invalid': $v.modalData.logistics_tab_name.$error,
                'is-valid': !$v.modalData.logistics_tab_name.$invalid,
              }"
              autocomplete="off"
              data-lpignore="true"
            />
            <b-form-invalid-feedback v-if="!$v.modalData.logistics_tab_name.required">
              Tab name is required.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <hr/>
        <div slot="modal-footer" class="w-100">
          <b-btn
            size="md"
            type="submit"
            class="btn btn-primary btn-md"
          >
            Update
          </b-btn>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CustomLoader from '@/components/CommonPages/CustomLoader.vue'

export default {
  name: 'DetailTabForm',
  props: ['type', 'refId', 'modalData'],
  components: { CustomLoader },
  data () {
    return {
      loader: false
    }
  },
  methods: {
    onSubmit(event) {
      this.$v.$touch();
      event.preventDefault();
      if (this.$v.$invalid) {
        this.$toasted.global.error("Please fill out the required fields.");
      } else {
        this.loader = true;
        this.$http.post(process.env.VUE_APP_API_URL + '/program_admin_toggle_rights/update_toggle', {
          program_admin_toggle_right: {
            page_name: this.type,
            logistics_tab_name: this.modalData.logistics_tab_name
          },
          page_name: this.type,
        })
        .then((res) => {
          if(res === undefined){
            //this.$toasted.global.error('Process has been failed.')
          }else if (res.data.error !== undefined) {
            this.$toasted.global.error(res.data.error)
          } else {
            this.$toasted.global.success('Updated Successfully')
            this.hideModal()
            this.loader = false;
          }
        })
      }
    },
    hideModal () {
      this.$root.$emit(`${this.refId}`)
    }
  },
  validations: {
    modalData: {
      logistics_tab_name: {
        required
      }
    }
  }
}
</script>
